import React from "react";
import styled from "styled-components";

// @ts-expect-error - JSXファイルの型定義なし
import OsFooter from "../os/components/OsFooter";
import useDocumentTitle from "../../hooks/useDocumentTitle";

import AboutHero from "./components/AboutHero";
import AboutFullpage from "./components/AboutFullpage";
import AboutSection from "./components/AboutSection";
import AboutProfile from "./components/AboutProfile";
import {
  ABOUT_CONCEPT,
  ABOUT_FEATURE,
  ABOUT_PROFILE,
  ABOUT_HERO_SUBTITLE,
} from "./aboutContent";

/**
 * 会社概要（/about）。旧 Django SSR ページの SPA 移植。
 * Hero → CONCEPT → FEATURE は /careers・/os と同じ全画面セクション（ページスナップ）、
 * PROFILE は通常の読みものセクション（見出しは /careers「募集職種」と同じ）。主要取引先も PROFILE の 1 項目。
 */
const AboutMain = styled.main`
  position: fixed;
  inset: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const AboutScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  /* 全画面セクションでページスナップ。PROFILE 以降は proximity なので自然に抜ける。
     /careers・/os と同じくモバイルでは無効（セクションが 1 画面に収まらないため） */
  @media (min-width: 768px) {
    scroll-snap-type: y proximity;
    scroll-behavior: smooth;
  }
`;

const SnapStart = styled.div`
  scroll-snap-align: start;
`;

const About: React.FC = () => {
  useDocumentTitle(ABOUT_HERO_SUBTITLE);

  return (
    <AboutMain>
      <AboutScrollArea>
        <SnapStart>
          <AboutHero />
        </SnapStart>

        <AboutFullpage copy={ABOUT_CONCEPT} theme="light" />
        <AboutFullpage copy={ABOUT_FEATURE} theme="blue" />

        <SnapStart>
          <AboutSection title="会社概要" subtitle="Profile">
            <AboutProfile rows={ABOUT_PROFILE} />
          </AboutSection>
        </SnapStart>

        <OsFooter />
      </AboutScrollArea>
    </AboutMain>
  );
};

export default About;
